export const PROJECT_EVERYTHING = {
    name            : 'Everything',
    icon            : 'i5-structure-1',
    url             : 'everything',
    inheritance     : false,
}
